import * as React from 'react'
import toast from 'react-hot-toast'

export function useCopyToClipboard() {
  const copyToClipboard = React.useCallback((textToCopy: string) => {
    if (!textToCopy) {
      return
    }

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        toast.success('Copied to clipboard!', {
          style: {
            background: 'white',
            color: '#272B2F',
          },
        })
      })
      .catch(() => {
        toast.error('Failed to copy')
      })
  }, [])

  return copyToClipboard
}
